module.exports = __webpack_public_path__ + "img/discount.344cad38.svg";